import { BREAKPOINT } from '@/constants/enum';
import { Button, Modal } from '@shopify/polaris';
import { ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';
import RegularText from '../RegularText';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  onConfirm?: () => void;
  title?: string;
  sectionText?: string;
  sectionContent?: ReactNode;
  primaryBtn?: ReactNode;
  secondaryBtn?: ReactNode;
}

const ModalConfirm = ({
  isOpen,
  isLoading,
  onClose,
  onConfirm,
  sectionText,
  title,
  sectionContent,
  primaryBtn,
  secondaryBtn,
}: IProps) => {
  const isMobile = useMediaQuery({ maxWidth: BREAKPOINT.SM });
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={title || 'Do you want to delete'}
      footer={
        <div
          style={{
            width: isMobile ? 'calc(100vw - 3rem)' : '588px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          {secondaryBtn ? secondaryBtn : <Button onClick={onClose}>Cancel</Button>}
          <div className="ml-8">
            {primaryBtn ? (
              primaryBtn
            ) : (
              <Button tone="critical" variant="primary" onClick={onConfirm} loading={isLoading}>
                Delete
              </Button>
            )}
          </div>
        </div>
      }
    >
      <Modal.Section>
        <RegularText>{sectionText ?? 'Once you delete, you will not be able to restore it.'}</RegularText>
        {sectionContent ? <div>{sectionContent}</div> : null}
      </Modal.Section>
    </Modal>
  );
};

export default ModalConfirm;
